/**
 * Client-side admin helpers.
 * Admin access is controlled by REACT_APP_ADMIN_EMAIL in .env
 */

/**
 * @returns {string[]} normalized admin emails from REACT_APP_ADMIN_EMAIL
 */
export const getAdminEmails = () => {
  return (process.env.REACT_APP_ADMIN_EMAIL || '')
    .split(',')
    .map(e => e.trim().toLowerCase())
    .filter(Boolean);
};

/**
 * @param {Object|null} currentUser
 * @returns {boolean}
 */
export const isAdminUser = currentUser => {
  const email = currentUser?.attributes?.email?.trim?.().toLowerCase?.();
  if (!email) return false;
  return getAdminEmails().includes(email);
};
